import React from 'react';

function Banner() {
  return (
    <header className="news-archive-header__wrapper">
      <h1 className="news-archive-header__title">News</h1>
      <p className="news-archive-header__date">
        Want to know what we are up to? BravoSUITE News rounds up all news,
        announcements, and other pertinent information that&#39;s happening at
        Bravo.
      </p>
    </header>
  );
}

export default Banner;
